import { FC, useContext } from "react";
import { IAnswer, IQuestion, QUESTION_TYPES } from "../../Tests/types";
import { useFormContext } from "react-hook-form";
import CustomCheckbox from "../../Tests/components/Ui/CustomCheckbox";
import CustomRadio from "../../Tests/components/Ui/CustomRadio";
import { PassingTestContext } from "../passingTestContext";
import SuccessfullyPassingTest from "src/components/ui-icons/tests/SuccessfullyPassingTest";
import RejectedPassingTest from "src/components/ui-icons/tests/RejectedPassingTest";

interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
  question: IQuestion;
}

const QuestionsCardTest: FC<IProps> = ({ question, ...props }) => {
  const { register, setValue, watch } = useFormContext();
  const { showResultsTest, answersResult } = useContext(PassingTestContext);
  const isQuestionTypeMultiple = question.Type === QUESTION_TYPES.MULTIPLE;
  const CustomInput = isQuestionTypeMultiple ? CustomCheckbox : CustomRadio;
  const checkCorrectQuestion = question.Answers.every((answer) => !!answer.IsCorrect === !!answersResult[answer.ID]);
  const resultQuestion =
    !!Object.keys(answersResult).length && showResultsTest ? (
      checkCorrectQuestion ? (
        <SuccessfullyPassingTest />
      ) : (
        <RejectedPassingTest />
      )
    ) : null;

  const handleChangeCheckBox = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.checked;
    setValue(e.target.name, inputValue);
  };

  const handleChangeRadio = (e: React.ChangeEvent<HTMLInputElement>) => {
    question.Answers.forEach((answer) => setValue(answer.ID.toString(), null));
    setValue(e.target.name, "on");
  };

  return (
    <div className="p-5 border rounded-md mb-[10px]">
      <div className="flex justify-between">
        <h2 className="mb-[10px]">{question.Description}</h2>
        {resultQuestion}
      </div>
      <p className="mb-5">
        {isQuestionTypeMultiple ? "Можно выбрать несколько вариантов ответа" : "Выберите 1 вариант ответа"}
      </p>
      <div className="flex flex-col gap-5">
        {question.Answers?.map((answer: IAnswer) => (
          <label id={props.id} key={answer.ID} className="flex gap-[10px] w-fit">
            <CustomInput
              disabled={!!Object.keys(answersResult).length && showResultsTest}
              {...register(answer.ID.toString())}
              {...props}
              id={answer.ID.toString()}
              onChange={isQuestionTypeMultiple ? handleChangeCheckBox : handleChangeRadio}
              checked={
                !!Object.keys(answersResult).length && showResultsTest
                  ? answersResult[answer.ID]
                  : watch(answer.ID.toString())
              }
              textClassName="whitespace-normal"
            >
              {answer.Description}
            </CustomInput>
          </label>
        ))}
      </div>
    </div>
  );
};
export default QuestionsCardTest;
